import { Col, Divider, Row, Steps, Table } from "antd";
import React, { useState } from "react";
import { CardBody } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
const PODetails = ({
  details,
  organisationDetails,
  projectDetails,
  // taxOptions,
}) => {
  const [track, setTrack] = useState([]);
  const [currentStep, setCurrentStep] = useState([]);
  // useEffect(() => {
  //   var trackNew = [];
  //   var createdAt = moment(details?.created_at);
  //   const formattedDate =
  //     moment(createdAt).format("ddd") +
  //     " " +
  //     moment(createdAt).format("MMM") +
  //     " " +
  //     moment(createdAt).format("DD") +
  //     " " +
  //     moment(createdAt).format("YYYY");
  //   var firstStep = {
  //     step: "PO Raised",
  //     description: formattedDate,
  //   };
  //   trackNew.push(firstStep);
  //   var steps = details?.approval_flow;
  //   var stepsCompleted = 1;
  //   for (var i = 0; i < steps?.length; i++) {
  //     if (steps[i]?.is_approved) stepsCompleted += 1;
  //     var newStep = {
  //       step: steps[i]?.project_member__user_organisation__user__name,
  //       description: steps[i]?.is_approved ? "Approved" : "Approval Pending",
  //     };
  //     trackNew.push(newStep);
  //   }
  //   var finalStep = {
  //     step: "PO Status",
  //     description: !details.is_approved ? "Pending" : "Approved",
  //   };
  //   trackNew.push(finalStep);
  //   if (details?.is_approved) {
  //     stepsCompleted = 1 + steps.length;
  //   }
  //   setCurrentStep(stepsCompleted);
  //   setTrack(trackNew);
  // }, []);

  const { Step } = Steps;
  // const taxFinder = (tax) => {
  //   if (tax) return taxOptions.filter((each) => each.id === tax)[0]?.percentage;
  //   return 0;
  // };
  const { userDetails, setUserDetails } = useAPIUser();
  const columns = [
    {
      title: "BOQ Item",
      key: "boq_item",
      render: (data) => (
        <span>
          {data?.sub_item ? data?.sub_item?.boq_sub_item : data?.item?.boq_item}
        </span>
      ),
    },
    {
      title: "Description",
      key: "item_description",
      render: (data) => (
        <span>
          {data?.sub_item
            ? data?.sub_item?.item_description
            : data?.item?.item_description}
        </span>
      ),
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
    },
    {
      title: "Unit",
      key: "unit",
      render: (data) => (
        <span>{data?.sub_item ? data?.sub_item?.unit : data?.item?.unit}</span>
      ),
    },
    {
      title: "Make/Brand",
      key: "brand",
      render: (data) => (
        <span>
          {data?.sub_item ? data?.sub_item?.brand : data?.item?.brand}
        </span>
      ),
    },
    {
      title: "Price",
      key: "budget_price",
      render: (data) => (
        <>
          <div>₹{data?.unit_po_price}</div>
          <div>
            Budget : ₹
            {data?.sub_item
              ? data?.sub_item?.budget_price
              : data?.item?.budget_price}
          </div>
        </>
      ),
    },
    {
      title: "Discount",
      key: "discount",
      dataIndex: "discount",
    },
    {
      title: "Tax",
      key: "tax",
      render: (data) => {
        var totalPrice = data?.unit_po_price * data?.quantity;
        var discount = data?.discount;
        var priceWGst = Number(totalPrice - discount);
        var tax = Number(data?.tax_value);
        return (
          <>
            <div>{tax}%</div>
            <span>Budget : {Number(priceWGst * tax * 0.01).toFixed(2)}</span>
          </>
        );
      },
    },
    {
      title: "Amount",
      key: "amount",
      dataIndex: "total_price",
    },
  ];
  var totalAmount = 0;
  details?.po_items?.map((each) => {
    totalAmount += each?.total_price;
  });
  return (
    <React.Fragment>
      <CardBody>
        {/* <div className="px-2">
          <Steps direction="horizontal" size="small" current={currentStep}>
            {track?.map((each, index) => (
              <Step
                key={index}
                title={each?.step}
                description={each?.description}
              />
            ))}
          </Steps>
        </div> */}
      </CardBody>
      <CardBody>
        <Row gutter={24}>
          <Col sm={12}>
            <img
              src="https://mysite-user-images.s3.ap-south-1.amazonaws.com/1659693186644-MD-for-procurement.svg"
              height={80}
            />
          </Col>
          <Col sm={12}>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Created By
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>
                    {" " +
                      userDetails.name +
                      " (" +
                      userDetails.contact +
                      ", " +
                      userDetails.email +
                      ")"}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Type of Order
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.type_of_order}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Delivery / Handover Date
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.delivery_date}</Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
      <Divider orientation="horizontal" />
      <Row gutter={24} className="mt-3">
        <Col sm={11}>
          <CardBody>
            <div className="">
              <H6>Bill To</H6>
            </div>
            <Row gutter={16}>
              <Col sm={5} md={5}>
                Name
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{organisationDetails?.name}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col sm={5} md={5}>
                Address
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.gst?.address}</Col>
                </Row>
              </Col>
            </Row>
            {/* <Row gutter={16} >
                      <Col sm={5} md={5}>
                        PIN Code
                      </Col>
                      <Col sm={19} md={19}>
                        <Row>
                          <Col sm={1}>:</Col>
                          <Col sm={11}></Col>
                        </Row>
                      </Col>
                    </Row> */}
            <Row gutter={16}>
              <Col sm={5} md={5}>
                GST
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.gst?.label}</Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Col>
        <Col>
          <Divider type="vertical" style={{ height: "100%" }} />
        </Col>
        <Col sm={11}>
          <CardBody>
            <div className="">
              <H6>Vendor Details</H6>
            </div>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Vendor Name
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{details?.vendor?.name}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Address
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>{details?.vendor?.billing_address}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Vendor Code
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>{details?.vendor?.vendor_code}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                Contact Details
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>
                    {details?.vendor?.contact}, {details?.vendor?.email}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24} className="">
              <Col sm={7} md={7}>
                GST
              </Col>
              <Col sm={17} md={17}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={23}>{details?.vendor?.gst}</Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Col>
      </Row>
      <Divider orientation="horizontal" />
      <CardBody>
        <H6>Ship To</H6>
        <Row gutter={24} className="mt-3">
          <Col sm={12}>
            <Row gutter={16}>
              <Col sm={4} md={4}>
                Name
              </Col>
              <Col sm={20} md={20}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={11}>{projectDetails?.project_name}</Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col sm={6}>Pincode</Col>
          <Col sm={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{details?.address?.pincode}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16} className="mt-2">
          <Col sm={6}>Contact person</Col>
          <Col sm={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{details?.address?.contact_person}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col sm={6}>Contact number</Col>
          <Col sm={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>{details?.address?.contact_phone}</Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={16} className="mt-1">
          <Col sm={6}>Selected address: </Col>
          <Col sm={18}>
            <Row>
              <Col sm={1}>:</Col>
              <Col sm={11}>
                {details?.address?.address}, {details?.address?.city}{" "}
                {details?.address?.pincode}
              </Col>
            </Row>
          </Col>
        </Row>
        {details?.address?.google_map_address && (
          <Row gutter={16} className="mt-1">
            <Col sm={6}>Google Map Address</Col>
            <Col sm={18}>
              <Row>
                <Col sm={1}>:</Col>
                <Col sm={11}>
                  <a href={details?.address?.google_map_address} target="_blank">
                    {
                      details?.address?.google_map_address?.length > 50
                        ? details?.address?.google_map_address?.substring(0, 50) + "..."
                        : details?.address?.google_map_address
                    }
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </CardBody>
      <Divider orientation="horizontal" />
      <CardBody>
        <Table
          dataSource={details?.items}
          columns={columns}
          scroll={{ x: "max-content" }}
          pagination={false}
        />
      </CardBody>
      <Divider orientation="horizontal" />

      <Row>
        <Col sm={11}>
          <CardBody>
            <H6>Payment Terms</H6>
            <CardBody>
              {details?.payment_terms?.map((each, ind) => (
                <div key={ind}>
                  {each?.term}:{each?.percentage}%
                </div>
              ))}
            </CardBody>
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            <H6>Terms and Conditions</H6>
            <CardBody>
              <div className="mb-2">
                {details?.terms_and_condition?.description}
              </div>
              <div className="">
                {details?.terms_and_conditions_description}
              </div>
            </CardBody>
          </CardBody>
        </Col>
        <Col>
          <Divider type="vertical" style={{ height: "100%" }} />
        </Col>
        <Col sm={12}>
          <CardBody>
            <div className="d-flex justify-content-between">
              <div className="">Taxable Amount</div>
              <div className="">{totalAmount}</div>
            </div>
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            {details?.additional_charges?.map((each, ind) => (
              <div className="d-flex justify-content-between" key={ind}>
                <div className="">
                  {each?.charge_type}
                  {` (@${each?.tax?.percentage + "%"} ${each?.tax?.tax_type})`}
                </div>
                <div className="">
                  {(
                    Number(each?.amount) +
                    Number(each?.amount) * Number(each?.tax_value) * 0.01
                  ).toFixed(2)}
                </div>
              </div>
            ))}
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            <div className="d-flex justify-content-between">
              <div className="">
                <H6>Total Amount</H6>
              </div>
              <div className="">
                {Number(details?.total_po_raised_amount).toFixed(2)}
              </div>
            </div>
          </CardBody>
        </Col>
      </Row>
      <Divider orientation="horizontal" />
    </React.Fragment>
  );
};

export default PODetails;
